"use client";

import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { AppBackground } from "@/components/app-background";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/ui/logo";

export function NotFoundPage() {
    return (
        <div className="relative flex min-h-[100dvh] flex-col items-center justify-center px-4">
            <AppBackground />
            <div className="relative z-10 mx-auto w-full max-w-md space-y-8 text-center">
                <Logo size="large" className="mx-auto block" />
                <div className="space-y-3">
                    <p className="text-xs font-medium uppercase tracking-[0.14em] text-muted-foreground">
                        404
                    </p>
                    <h1 className="text-balance text-3xl font-bold tracking-tight">Page not found</h1>
                    <p className="text-sm leading-relaxed text-muted-foreground">
                        That route doesn&apos;t exist or may have moved. Head back to the dashboard to
                        continue chasing the aurora.
                    </p>
                </div>
                <div className="flex flex-col justify-center gap-3 sm:flex-row">
                    <Button asChild>
                        <Link to="/">
                            <ArrowLeft data-icon="inline-start" />
                            Back to dashboard
                        </Link>
                    </Button>
                    <Button variant="outline" asChild>
                        <Link to="/map">Open map</Link>
                    </Button>
                </div>
            </div>
        </div>
    );
}
